import hero1 from './bg-hero.webp';
import carWash from './carwash.webp';
import carRent from './carrent.webp';
import sub from './subscription.webp';
import cfs from './cfs.webp';

export const images = {
  hero1,
  carWash,
  carRent,
  sub,
  cfs,
};
